import { Button, Drawer, Flex } from "antd";
import { DrawerContent } from "components/UI/DrawerContent/DrawerContent.tsx";
import { DrawerTitle } from "components/UI/DrawerTitle/DrawerTitle.tsx";
import { TextEditor } from "components/UI/TextEditor/TextEditor.tsx";
import { usePaldockTranslation } from "hooks/usePaldockTranslation.tsx";
import { useCallback, useEffect, useState } from "react";

interface NotesDrawerProps {
    open: boolean;
    onClose: () => void;
    value?: string;
    onChange?: (value: string) => void;
}

export const NotesDrawer = ({ open, onClose, value = "", onChange }: NotesDrawerProps) => {
    const { t } = usePaldockTranslation("components.connection-creator");
    const { t: tC } = usePaldockTranslation("common");
    const [content, setContent] = useState(value);

    // Sync internal state with external value when drawer opens
    useEffect(() => {
        if (open) {
            setContent(value);
        }
    }, [open, value]);

    const handleSave = useCallback(() => {
        onChange?.(content);
        onClose();
    }, [content, onChange, onClose]);

    const handleContentChange = useCallback((newContent: string) => {
        setContent(newContent);
    }, []);

    return (
        <Drawer
            open={open}
            onClose={onClose}
            title={<DrawerTitle mainTitle={t("notes.title")} />}
            width={600}
            extra={
                <Flex gap="small">
                    <Button size="large" onClick={onClose}>
                        {tC("cancel")}
                    </Button>
                    <Button size="large" type="primary" onClick={handleSave}>
                        {tC("save")}
                    </Button>
                </Flex>
            }
        >
            <DrawerContent>
                <div
                    className="notes-editor-wrapper"
                    style={{
                        minHeight: 600,
                        resize: "vertical",
                        overflow: "auto",
                    }}
                >
                    <TextEditor
                        value={content}
                        onChange={handleContentChange}
                        style={{ height: "100%", minHeight: 560 }}
                    />
                </div>
            </DrawerContent>
        </Drawer>
    );
};
